<app-nav [navItems]="navItems" />
<div class="static">
  <h1>Privacy policy</h1>
  <p><span>Effective Date:</span>21.08.2024</p>
  <p>
    At ImageBase.pro, we value your privacy and are committed to protecting your
    personal information. This Privacy Policy explains how we collect, use, and
    safeguard your data when you visit our website or use our services. By
    accessing our platform, you agree to the practices described in this policy.
  </p>
  <p>
    <strong>1. Data Controller</strong>
  </p>
  <p>
    The data controller for personal data processed through ImageBase.pro is:
  </p>
  <p>
    <strong>DIGITAL DP LTD</strong><br />
    82a James Carter Road, Mildenhall,<br />
    Bury St. Edmunds, England, IP28 7DE<br />
    <span>Email:</span>
    <a
      [href]="'mailto:' + environment.support_email"
      [textContent]="environment.support_email"
    ></a>
  </p>
  <p><strong>2. Information We Collect</strong></p>
  <p>We collect the following types of information:</p>
  <p><strong>2.1. Information You Provide</strong></p>
  <ul>
    <li>
      <strong>Account Information:</strong> Name, email address, and password
      when you register an account.
    </li>
    <li>
      <strong>Payment Information: </strong> Billing address, payment method
      details (processed securely via third-party payment providers).
    </li>
    <li>
      <strong>Support Requests: </strong> Information shared when contacting
      customer support.
    </li>
  </ul>
  <p><strong>2.2. Information Collected Automatically</strong></p>
  <ul>
    <li>
      <strong>Usage Data: </strong> IP address, browser type, operating system,
      and access times.
    </li>
    <li>
      <strong>Cookies and Tracking Data: </strong> Data collected through
      cookies and similar tracking technologies to improve user experience.
    </li>
  </ul>
  <p><strong>2.3. Information from Third Parties</strong></p>
  <ul>
    <li>
      Payment processors and service providers may share transactional data to
      ensure successful order processing.
    </li>
  </ul>
  <p><strong>3. How We Use Your Information</strong></p>
  <p>We use your personal data for the following purposes:</p>
  <ul>
    <li>
      <strong>Account Management:</strong> To create and manage your account.
    </li>
    <li>
      <strong>Transaction Processing:</strong> To process payments and fulfill
      orders.
    </li>
    <li>
      <strong>Improving Services:</strong> To analyze user behavior and improve
      the platform’s functionality.
    </li>
    <li>
      <strong>Customer Support:</strong> To respond to inquiries and provide
      assistance.
    </li>
    <li>
      <strong>Legal Compliance:</strong> To comply with legal and regulatory
      requirements.
    </li>
  </ul>
  <p><strong>4. Sharing Your Information</strong></p>
  <p>
    We only share your information with trusted third parties when necessary:
  </p>
  <ul>
    <li>
      <strong>Payment Processors:</strong> For secure payment transactions.
    </li>
    <li>
      <strong>Service Providers:</strong> For hosting, analytics, and email
      communication.
    </li>
    <li>
      <strong>Legal Authorities:</strong> If required by law or to protect our
      rights.
    </li>
  </ul>
  <p>We do not sell or rent your personal information to third parties.</p>
  <p><strong>5. Cookies and Tracking Technologies</strong></p>
  <p>
    Cookies are small files stored on your device to enhance your experience on
    our site. We use cookies to:
  </p>
  <ul>
    <li>Recognize your preferences.</li>
    <li>Measure website performance.</li>
    <li>Provide relevant content and advertisements.</li>
  </ul>
  <p>
    You can manage your cookie preferences through your browser settings.
    Disabling cookies may affect the functionality of the platform.
  </p>
  <p><strong>6. Data Retention</strong></p>
  <p>We retain your personal data for as long as necessary to:</p>
  <ul>
    <li>Provide our services.</li>
    <li>Comply with legal obligations.</li>
    <li>Resolve disputes and enforce agreements.</li>
  </ul>
  <p>When no longer needed, we securely delete or anonymize your data.</p>
  <p><strong>7. Your Rights</strong></p>
  <p>You have the following rights regarding your personal data:</p>
  <ul>
    <li>
      <strong>Access:</strong> Request a copy of the information we hold about
      you.
    </li>
    <li><strong>Correction:</strong> Update inaccurate or incomplete data.</li>
    <li>
      <strong>Deletion:</strong> Request the removal of your data (subject to
      legal obligations).
    </li>
    <li>
      <strong>Restriction:</strong> Limit the processing of your data in certain
      circumstances.
    </li>
    <li>
      <strong>Portability:</strong> Receive your data in a structured,
      machine-readable format.
    </li>
    <li>
      <strong>Objection:</strong> Object to processing based on legitimate
      interests or direct marketing.
    </li>
  </ul>
  <p>
    To exercise these rights, please contact us at
    <a
      [href]="'mailto:' + environment.support_email"
      [textContent]="environment.support_email"
    ></a
    >.
  </p>
  <p><strong>8. Data Security</strong></p>
  <p>
    We implement robust technical and organizational measures to protect your
    personal data from unauthorized access, alteration, or disclosure. Despite
    these measures, no method of transmission over the Internet or electronic
    storage is 100% secure.
  </p>
  <p><strong>9. International Transfers</strong></p>
  <p>
    As a UK-based company, your data may be transferred and stored outside your
    country of residence. We ensure that any such transfers comply with
    applicable data protection laws by using standard contractual clauses or
    other appropriate safeguards.
  </p>
  <p><strong>10. Third-Party Links</strong></p>
  <p>
    Our platform may contain links to third-party websites. We are not
    responsible for the privacy practices of these external sites. We encourage
    you to review their privacy policies before providing any personal
    information.
  </p>
  <p><strong>11. Changes to This Privacy Policy</strong></p>
  <p>
    We may update this Privacy Policy from time to time to reflect changes in
    our practices or for legal reasons. Any updates will be posted on this page,
    and the "Effective Date" will be updated accordingly.
  </p>
  <p><strong> 12. Contact Information</strong></p>
  <p>
    If you have any questions or concerns about this Privacy Policy or our data
    practices, please contact us:
  </p>
  <p>
    <strong>DIGITAL DP LTD</strong><br />
    82a James Carter Road, Mildenhall,<br />
    Bury St. Edmunds, England, IP28 7DE<br />
    <span>Email:</span>
    <a
      [href]="'mailto:' + environment.support_email"
      [textContent]="environment.support_email"
    ></a>
  </p>
  <p>
    Thank you for trusting ImageBase.pro. Your privacy is important to us, and
    we are committed to protecting your personal information.
  </p>
</div>
